<template>
  <div>
    <el-dialog
      :visible="visible"
      :show-close="false"
      width="624px"
      custom-class="lenders"
      center>
      <div class="lendersInfo add-lendersInfo">
        <div class="head">
          <div class="title">申请退款</div>
          <div class="closeBtn" @click="addShowClose">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <div class="body">
          <div class="body-title">
            <div>退款原因</div>
            <div>（必须）</div>
          </div>
          <div class="body-list">
            <div class="body-item" :class="{'body-item-select':cause===index + 1}" v-for="(item,index) in options" :key="index" @click="optionsChange(index+1)">
              <div class="body-item-label">
                {{item}}
              </div>
              <div class="body-item-option" :class="{'body-item-option-select':cause===index + 1}" >
                <div></div>
              </div>
            </div>
          </div>
          <div class="body-tip" v-show="!cause">
            <div>
              未选中任何选项
            </div>
          </div>
          <div class="btn-group">
            <div class="btn" @click="addShowClose">取消退款</div>
            <button v-prevent-re-click class="btn confirm" @click="submitForm()">确认退款</button>
          </div>
<!--          <el-form :model="addForm" :rules="rules" ref="addForm" label-width="90px" class="addForm">
            <el-form-item label="收款人" prop="account_user_name">
              <el-input v-model="addForm.account_user_name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="收款方式" prop="account_type">
              <el-select v-model="addForm.account_type" placeholder="请选择收款方式">
                <el-option label="支付宝" :value="2"></el-option>
                <el-option label="微信" :value="3"></el-option>
                <el-option label="银行卡" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="收款账号" prop="account">
              <el-input v-model="addForm.account" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="account_bank_name" v-if="addForm.account_type == 1">
              <el-input v-model="addForm.account_bank_name" placeholder="请输入xxx省xxx市xxx开户行"></el-input>
            </el-form-item>
          </el-form>
          <div class="btn-group">
            <div class="btn" @click="addShowClose">取消</div>
            <button v-prevent-re-click class="btn confirm" @click="submitForm('addForm')">保存</button>
          </div>-->

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  apicreateRefund,
  apiOrderRefund
} from "@/request/API";

export default {
  name: "buyerLendersInfo",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    game_id: {
      type: Number,
      default: null
    },
    order_id: {
      type: Number,
      default: null
    },
  },
  components: {},
  data() {
    return {
      addForm: {
        account_user_name: '',
        account_type: '',
        account: '',
        account_bank_name: '',
      },
      rules: {
        account_user_name: [
          {required: true, message: '请输入收款人', trigger: 'blur'},
          // { pattern: /^[\u4e00-\u9fa5]{0,}$/, message: '仅限输入中文', trigger: 'blur' }
        ],
        account_type: [
          {required: true, message: '请选择收款方式', trigger: 'change'}
        ],
        account: [
          {required: true, message: '请输入收款账号', trigger: 'blur'},
        ],
        account_bank_name: [
          {required: true, message: '请输入开户行', trigger: 'blur'},
        ],
      },
      options:[
        '无理由',
        '不想要了',
        '卖家不发货',
        '想买其他商品',
        '需要部分退款'
      ],
      cause:''
    }
  },
  methods: {
    /**
     * 新增放款信息弹窗关闭
     */
    addShowClose() {
      // this.$refs['addForm'].resetFields();
      this.$emit('update:visible', false)
    },
    /**
     * 新增放款信息表单提交
     */
    submitForm() {
/*      this.$refs[formName].validate((valid) => {
        if (valid) {
          let p = {
            order_id: this.order_id,
            user_name: this.addForm.account_user_name,
            user_account: this.addForm.account,
            user_method: this.addForm.account_type,
            bank_name: this.addForm.account_bank_name,
          }
          apicreateRefund(p).then(res => {
            this.$message({
              center: true,
              type: 'success',
              message: '提交成功'
            })
            this.addShowClose()
            this.$emit('refresh')
          }).catch(() => {
            this.$message({
              center: true,
              type: 'error',
              message: '提交失败'
            })
            this.addShowClose()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });*/
      if (!this.cause) {
        this.$message({
          center: true,
          type: 'error',
          message: '未选中任何选项'
        })
        return
      }
      apiOrderRefund({
        id:this.order_id,
        reason_type:this.cause
      }).then(res=>{
        this.$message({
          center: true,
          type: 'success',
          message: res.msg
        })
        this.addShowClose()
        this.$emit('refresh')
      }).catch(e=>{
        this.$message({
          type:'error',
          center:true,
          message:e.msg
        })
        this.addShowClose()
      })
    },

    /**
     * 退款原因选择
     * @param index 下标
     */
    optionsChange(index){
      this.cause = index
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(()=> {
          // this.$refs['addForm'].resetFields()
        })
      }
    },
  },
  created() {},
  mounted() {}
}
</script>

<style scoped lang="less">

/deep/ .lenders {
  border-radius: 4px;
  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  .el-icon-close {
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 800;
  }
}

/deep/ .del {
  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  .el-icon-close {
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 800;
  }
}

.lendersInfo {
  .head {
    height: 66px;
    line-height: 66px;
    text-align: center;
    background: linear-gradient(135deg, #6F7883 0%, #1A1D24 100%);
    border-radius: 4px 4px 0 0;
    position: relative;

    .title {
      font-size: 22px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .closeBtn {
      font-size: 30px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      position: absolute;
      right: 23px;
      top: 0;
      cursor: pointer;
    }
  }

  .body {
    //width: 642px;
    //padding: 29px 0 37px;
    padding: 20px 142px 39px;

    .list {
      height: 201px;
      overflow: auto;

      .item {
        height: 65px;
        padding: 0 25px 0 26px;
        display: flex;
        justify-content: center;

        #item {
          cursor: pointer;
          display: flex;
          align-items: center;
          border-bottom: 2px solid #E6E9EF;
          padding: 0 46px 0 45px;

          .radio {
            width: 16px;
            height: 16px;
            border-radius: 4px;
            cursor: pointer;
            border: 2px solid #E0E0E0;
          }

          .info {
            margin: 0 20px;

            .payment-methods {
              display: flex;
              align-items: center;
              font-size: 14px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #000000;
              margin: 0 0 5px;

              i {
                margin: 0 5px 0 0;
              }

            }

            .payment-account {
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #777777;
              width: 364px;

              span {
                margin: 0 10px 0 0;
              }
            }
          }

          .item-btn-group {
            display: flex;
            align-items: center;

            div {
              width: 20px;
              height: 20px;

              i {
                font-size: 20px;
                color: #989898;
              }
            }

            div:first-of-type {
              margin: 0 18px 0 0;
            }
          }
        }

        &:hover {
          background: #FFFAF0;

        }
      }

      .checkItem {
        background: #FFFAF0;

        #item {
          .radio {
            width: 20px;
            height: 20px;
            border-radius: 4px;
            border: none;
            background: linear-gradient(135deg, #FFD43F 0%, #FF7D34 100%);
            display: flex;
            align-items: center;
            justify-content: center;

            div {
              width: 10px;
              height: 10px;
              border-radius: 4px;
              background: #FFFFFF;
            }
          }
        }
      }
    }

    .list::-webkit-scrollbar-track {
      border-radius: 4px;
      background: transparent;
    }

    .list::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }

    .list::-webkit-scrollbar-thumb {
      border-radius: 4px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }

    .add {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 9px 0 29px;
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #888C90;
      cursor: pointer;
      user-select: none;

      i {
        font-size: 20px;
        margin: 0 4px 0 0;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 1000;
      }
    }

    .body-title{
      padding: 0 10px 20px;
      margin: 0 0 20px;
      border-bottom: 1px solid #EFEFEF;
      display: flex;
      align-items: center;
      justify-content: space-between;
      div{
        font-size: 18px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      div:last-of-type{
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
      }
    }

    .body-list{
      padding: 0 10px ;
      margin: 0 0 20px;
      height: 146px;
      overflow: auto;
      &::-webkit-scrollbar-track {
        border-radius: 4px;
        background: transparent;
      }

      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(0, 0, 0, 0.2);
      }

      .body-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 20px 0 0;
        cursor: pointer;
        .body-item-label{
          font-size: 16px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #7A7A7A;
        }
        .body-item-option{
          border-radius: 4px;
          width: 16px;
          height: 16px;
          opacity: 1;
          border: 1px solid #D3D3D3;
        }
        .body-item-option-select{
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(252,173,19,0.5);
          div{
            border-radius: 4px;
            width: 10px;
            height: 10px;
            background: #FCAD13;
          }
        }
      }
      .body-item:first-of-type{
        margin: 0;
      }
    }

    .body-tip{
      margin: 0 0 21px;
      width: 100%;
      height: 28px;
      background: #FFECEC;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #EA8B8B;
      line-height: 28px;
      text-align: center;
    }

    .btn-group {
      display: flex;
      align-items: center;
      justify-content: center;

      .btn {
        width: 158px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #666666;
        cursor: pointer;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        user-select: none;
        border-radius: 4px;
      }

      .confirm {
        background: #FFDB51;
        border: 1px solid #FFDB51;
        color: #333333;
        margin: 0 0 0 15px;
      }
    }
  }

}

.del-body {
  padding: 26px 0 35px;

  .title {
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #353535;
    text-align: center;
  }

  .text {
    margin: 21px 0 17px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #696969;

    span {
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #F0EDE8;
    }
  }

  .btn-group {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn {
      width: 138px;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #000000;
      cursor: pointer;
      font-size: 16px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      user-select: none;
      border-radius: 4px;
    }

    .confirm {
      background: #FFDB51;
      border: 1px solid #FFDB51;
      color: #000000;
      margin: 0 0 0 15px;
    }
  }

}

.add-lendersInfo {
  .body {
    .addForm {
      margin: 0 0 32px 87px;

      /deep/ .el-form-item {
        display: flex;
        align-items: center;
      }

      /deep/ .el-form-item__content {
        margin: 0 0 0 24px !important;
      }

      /deep/ .el-form-item__label {
        padding: 0;
        flex-shrink: 0;
        font-size: 16px !important;
        font-family: PingFang SC-Medium, PingFang SC !important;
        font-weight: 500 !important;
        color: #1A1D24 !important;
        float: none;
      }

      /deep/ .el-input__inner {
        width: 360px;
        height: 45px;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #E3E3E3;

        &::placeholder {
          font-size: 14px;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ACACAC;
        }

        &:focus {
          border: 1px solid #FCAD13;

        }
      }
    }
  }
}

/deep/ .lenders {
  overflow: hidden;
  border-radius: 4px;
  background: var(--bg-card, #FFFFFF);
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__header,
  .el-dialog__body {
    padding: 0 !important;
  }
}

.lendersInfo {
  background: var(--bg-card, #FFFFFF);
  border-radius: 4px;

  .head {
    height: 54px;
    line-height: 54px;
    border-radius: 4px 4px 0 0;
    background: var(--bg-dark, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));

    .title {
      color: #FFFFFF;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1px;
    }

    .closeBtn {
      top: 0;
      right: 20px;
      width: 22px;
      height: 54px;
      color: rgba(255, 255, 255, 0.86);
      font-size: 20px;
      line-height: 54px;
      transition: color .2s ease, transform .2s ease;
    }

    .closeBtn:hover {
      color: #FFFFFF;
      transform: rotate(90deg);
    }
  }

  .body {
    padding: 28px 96px 34px;
    background: var(--bg-card, #FFFFFF);
    border-radius: 0 0 4px 4px;

    .body-title {
      margin: 0 0 18px;
      padding: 0 2px 16px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);

      div {
        color: var(--text-main, #111827);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
      }

      div:last-of-type {
        color: var(--text-muted, #9AA0AC);
        font-size: 13px;
        font-weight: 400;
      }
    }

    .body-list {
      height: 172px;
      margin: 0 0 18px;
      padding: 0 2px;

      &::-webkit-scrollbar-thumb {
        background: rgba(148, 163, 184, 0.42);
        box-shadow: none;
      }

      .body-item {
        height: 40px;
        margin: 8px 0 0;
        padding: 0 12px;
        border: 1px solid transparent;
        border-radius: 4px;
        background: transparent;
        transition: border-color .2s ease, background .2s ease;

        .body-item-label {
          color: var(--text-secondary, #5A5F6B);
          font-family: PingFang SC-Regular, PingFang SC;
          font-size: 14px;
          font-weight: 400;
        }

        .body-item-option {
          width: 16px;
          height: 16px;
          border: 1px solid var(--border-strong, #CBD5E1);
          border-radius: 50%;
          background: var(--bg-card, #FFFFFF);
        }

        .body-item-option-select {
          border-color: var(--primary, #FF5A1F);
          background: var(--primary-soft, #FCEDE5);

          div {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: var(--primary, #FF5A1F);
          }
        }
      }

      .body-item:first-of-type {
        margin-top: 0;
      }

      .body-item:hover {
        border-color: var(--border-soft, #E8E4DE);
        background: var(--bg-tag, #F0EDE8);
      }

      .body-item-select {
        border-color: rgba(255, 90, 31, 0.34);
        background: var(--primary-soft, #FCEDE5);

        .body-item-label {
          color: var(--primary, #FF5A1F);
          font-weight: 500;
        }
      }
    }

    .body-tip {
      height: 30px;
      margin: 0 0 18px;
      border-radius: 4px;
      background: var(--danger-soft, #FEF2F2);
      color: var(--hot, #FF2D55);
      font-family: PingFang SC-Regular, PingFang SC;
      font-size: 13px;
      font-weight: 500;
      line-height: 30px;
    }

    .btn-group {
      gap: 12px;

      .btn {
        width: 140px;
        height: 38px;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        background: var(--bg-card, #FFFFFF);
        color: var(--text-secondary, #5A5F6B);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 15px;
        font-weight: 500;
        transition: border-color .2s ease, color .2s ease, background .2s ease, box-shadow .2s ease, opacity .2s ease;
      }

      .btn:hover {
        border-color: var(--bg-dark, #1A1D24);
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }

      .confirm {
        margin: 0;
        border: none;
        background: var(--primary, #FF5A1F);
        color: #FFFFFF;
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
      }

      .confirm:hover {
        color: #FFFFFF;
        background: var(--primary-hover, #E84A12);
        box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
        opacity: 1;
      }
    }
  }
}
</style>
